
var stache = require('can/view/stache/stache');
module.exports = stache("<span>{{formatted}}</span>\r\n");